import { Button } from "@/components/ui/button"
import { BodyMedium, H3, Small } from "@/components/ui/typography"
import { FileDown } from "lucide-react"
import React from "react"

type PaywallBannerProps = {
	price: string
	onExport: () => void
	onUnlock: () => void
	dateRange: string
}

export const PaywallBanner: React.FC<PaywallBannerProps> = ({
	onExport,
	onUnlock,
	dateRange,
	price,
}) => {
	return (
		<div className="border rounded-lg p-6 flex items-center justify-between mt-[-140px] relative bg-white z-10">
			<div>
				<H3>
					Unlock the Full Report for{" "}
					<span className="text-primary">{price}</span>
				</H3>
				<Small className="text-muted-foreground font-normal">
					Export to PDF | {dateRange}
				</Small>
			</div>
			<div className="flex items-center gap-3">
				<Button
					variant="outline"
					className="gap-2 text-foreground"
					size={"lg"}
					onClick={onExport}
				>
					🔒 Export to PDF
					<FileDown className="w-4 h-4" />
				</Button>
				<Button
					onClick={onUnlock}
					size={"lg"}
					className="text-primary-foreground"
				>
					Unlock Now
				</Button>
			</div>
		</div>
	)
}
